<template >
  <div>
    <div class="back-img"/>
    <div class="opacity"/>
    <TopMenu
      no-menu
      no-background
      no-back/>
    <div class="logo">
      <a
        href="http://sqc.ca"
        target="_blank"><img
          src="../../assets/images/SQC_logo_signature_white.svg"
          alt="Syndicat Québécois Construction"
          width="150" ></a>
    </div>
    <div class="login text-center">
      <form
        class="form-signin"
        @submit.prevent="login">
        <h1 class="h3 mb-3 font-weight-normal baseColor">{{ $t("LOGIN.PAGE_LABEL") }}</h1>
        <label
          for="inputEmail"
          class="sr-only">{{ $t("LOGIN.EMAIL_ADDRESS_PLACEHOLDER") }}</label>
        <input
          id="inputEmail"
          v-model="email"
          :placeholder="$t('LOGIN.EMAIL_ADDRESS_PLACEHOLDER')"
          type="email"
          class="form-control"
          required
          autofocus>
        <label
          for="inputPassword"
          class="sr-only">{{ $t("LOGIN.PASSWORD_PLACEHOLDER") }}</label>
        <input
          id="inputPassword"
          v-model="password"
          :placeholder="$t('LOGIN.PASSWORD_PLACEHOLDER')"
          type="password"
          class="form-control"
          required>
        <TextLink
          to="/forgot-password"
          class-name="d-inline-block mt-2 mb-2 baseColor">{{ $t("LOGIN.FORGOT_PASSWORD_TEXT") }}</TextLink>
        <ActionButton
          type="submit"
          class-name="btn btn-lg btn-secondary btn-block">{{ $t("LOGIN.SIGN_IN_BUTTON_TEXT") }}</ActionButton>
        <LanguagePicker/>
        <Copyright/>
      </form>
    </div>
  </div>
</template>

<script>
import TopMenu from '@/components/Menu/TopMenu';
import TextLink from '@/components/Utils/TextLink';
import ActionButton from '@/components/Actions/ActionButton';
import LanguagePicker from '@/components/Utils/LanguagePicker';
import Copyright from '@/components/Utils/Copyright';

export default {
  name: 'Login',
  components: {
    TopMenu,
    ActionButton,
    Copyright,
    LanguagePicker,
    TextLink,
  },
  data() {
    return {
      email: '',
      password: '',
    };
  },
  created() {
    if (localStorage.loginEmail) {
      this.email = localStorage.loginEmail;
    }
  },
  methods: {
    login() {
      this.$store.dispatch('user/login', {
        username: this.email,
        password: this.password,
      });
      localStorage.loginEmail = this.email;
    },
  },
};
</script>

<style scoped lang="scss">
.back-img {
  background-image: url("../../assets/images/background_image_login.jpg");
  background-size: cover;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
  background-position: center;
}
.opacity {
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  top: 0;
  z-index: -1;
}
.logo {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  background-color: $primary;
  width: 175px;
  margin-left: auto;
  margin-right: auto;
}
div {
  &.login {
    min-height: 100%;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-align: center;
    -ms-flex-pack: center;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 20px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
